var loader = require('./dist/debugModule');

module.exports = loader;